/**
 * Created by Oles on 4/27/2017.
 */
import { PatientActions, TestActions, ResultsTableActions } from '../const/ActionsConst';
import { MessageBoxHeaders, MessageBoxTexts, MessageBoxCancelBtnTexts, MessageBoxConfirmBtnTexts, TestStatuses, MessageBoxTypes } from '../const/TestResultsConst';
import { LOAD_TRANSLATIONS, SET_LOCALE } from 'react-redux-i18n/build/actions'; //TODO: a dirty hack to enable i18n, reducer should be rewritten to be used via combineReducers()
import { generateId } from '@common/utils/common';

const initialState = {
    patient: {
        id: 0,
        name: ''
    },
    tests: [],
    currentTestId: undefined,
    currentDoc: undefined,
    testDetails: {
        test: {
            id: undefined,
            submittedDate: undefined,
            reportedDate: undefined,
            reclassDate: undefined,
            lab: undefined,
            testOrdered: undefined,
            testStatus: undefined,
            documents: [],
            notes: undefined,
            genes: [],
            potentialFamilyMemberReports: undefined
        },
        show: false,
        saving: false,
        errors: {
            submittedDate: false,
            reportedDate: false,
            reclassDate: false
        },
        files: [],
        toDelete: [],
        multipleReports: {
            show: false
        },
    },
    messageBox: {
        type: undefined,
        header: '',
        text: '',
        show: false
    },
    testResultsColumnWidths: {
        'Actions': 5,
        'Submitted Date': 7,
        'Reported Date': 7,
        'Reclass Date': 7,
        'Lab': 10,
        'Test Ordered': 17,
        'Test Status': 7,
        'Result': 17,
        'Document': 7,
        'Notes': 16
    },
    testColumns: [
        {
            title: 'Actions',
            width: 60,
            minWidth: 60,
            default: undefined
        },
        {
            title: 'Lab',
            width: undefined,
            minWidth: 60,
            default: 7
        },
        {
            title: 'Test',
            width: undefined,
            minWidth: 70,
            default: 15
        },
        {
            title: 'Submitted Date',
            width: undefined,
            minWidth: 100,
            default: 7
        },
        {
            title: 'Reported Date',
            width: undefined,
            minWidth: 100,
            default: 7
        },
        {
            title: 'Reclass Date',
            width: undefined,
            minWidth: 100,
            default: 7
        },
        {
            title: 'Status',
            width: undefined,
            minWidth: 70,
            default: 7
        },
        {
            title: 'Result',
            width: undefined,
            minWidth: 70,
            default: 15
        },
        {
            title: 'Document',
            width: undefined,
            minWidth: 70,
            default: 7
        },
        {
            title: 'Notes',
            width: undefined,
            minWidth: 260,
            default: 20
        }
    ],
    blacklistFileExtensions: []
};

const testResults = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_TRANSLATIONS:
            return {
                ...state,
                i18n: {
                    ...state.i18n,
                    translations: action.translations,
                }
            };
        case SET_LOCALE:
            return {
                ...state,
                i18n: {
                    ...state.i18n,
                    locale: action.locale,
                }
            };
        case PatientActions.SHOW_TEST_DETAILS:
            if (!action.show) {
                return {
                    ...state,
                    testDetails: {
                        ...state.testDetails,
                        show: action.show,
                        test: initialState.testDetails.test, // clear testDetails.test object
                        errors: initialState.testDetails.errors, // clear testDetails.errors object
                        files: [],
                    }
                };
            }
            var test = state.tests.filter(test => test.id === action.id)[0] ? state.tests.filter(test => test.id === action.id)[0] : undefined;
            return {
                ...state,
                testDetails: {
                    ...state.testDetails,
                    test: test ? test : state.testDetails.test,
                    show: action.show,
                    toDelete: []
                }
            };

        case PatientActions.SET_TEST_RESULTS:
            return {
                ...state,
                tests: action.tests
            };
        case PatientActions.SHOW_MESSAGE_BOX:
            return {
                ...state,
                messageBox: {
                    ...state.messageBox,
                    type: action.messageBox.type,
                    header: action.messageBox.type ? MessageBoxHeaders[action.messageBox.type] : '',
                    text: action.messageBox.text ? action.messageBox.text : (action.messageBox.type ? MessageBoxTexts[action.messageBox.type] : ''),
                    show: action.messageBox.show,
                    confirmText: action.messageBox.type ? MessageBoxConfirmBtnTexts[action.messageBox.type] : 'OK',
                    cancelText: action.messageBox.type ? MessageBoxCancelBtnTexts[action.messageBox.type] : 'Cancel',
                    size: action.messageBox.size,
                    data: action.messageBox.data
                },
                testDetails: {
                    ...state.testDetails,
                    multipleReports: {
                        show: action.messageBox.type === MessageBoxTypes.MULTIPLE_REPORTS
                    }
                }
            };
        case PatientActions.SET_CURRENT_TEST:
            return {
                ...state,
                currentTestId: action.id
            };
        case TestActions.SET_CURRENT_DOC:
            return {
                ...state,
                currentDoc: (action.id == undefined && action.name == undefined) ? undefined : {id: action.id, name: action.name, doDelete: action.doDelete}
            };
        case PatientActions.SET_LABS:
            var labs = action.labs;
            labs.push({ // add "other" lab
                name: "Other",
                tests: []
            });
            for (var i = 0; i < labs.length; i++) { // add "other", "single-gene" and "single-site" tests
                labs[i].tests.push({
                    genes: [],
                    name: "Other"
                });
                labs[i].tests.push({
                    genes: [],
                    name: "Single-Gene"
                });
                labs[i].tests.push({
                    genes: [],
                    name: "Single-Site"
                })
            }
            return {
                ...state,
                labs: labs
            };
        case PatientActions.SET_GENES:
            return {
                ...state,
                genes: action.genes
            };
        case TestActions.EDIT_TEST:
        case TestActions.REMOVE_TEST:
            return {
                ...state,
                tests: testsTools(state.tests, action)
            };
        case TestActions.ADD_GENES_TABLE_ROW:
        case TestActions.DELETE_GENES_TABLE_ROW:
        case TestActions.UPDATE_TEST_DETAILS:
        case TestActions.SELECT_ALL_GENES:
        case TestActions.SELECT_GENE:
        case TestActions.UPDATE_GENES_TABLE_ROW:
        case TestActions.SELECT_TEST_STATUS:
        case TestActions.SET_VALIDATION_RESULT:
        case TestActions.UPLOAD_DOCS:
        case TestActions.UNLOAD_DOC:
        case TestActions.DELETE_DOC:
        case PatientActions.SET_TEST_DETAILS_SAVING:
        case TestActions.SET_DOC_TO_DELETE:
            return {
                ...state,
                testDetails: testDetailsTools(state.testDetails, action)
            };
        case TestActions.SELECT_LAB:
            var lab = action.lab && action.lab.length > 0 ? action.lab : undefined;
            return {
                ...state,
                testDetails: {
                    ...state.testDetails,
                    test: {
                        ...state.testDetails.test,
                        lab: lab,
                        testOrdered: undefined,
                        genes: []
                    }
                }
            };
        case TestActions.SELECT_TEST_ORDERED:
            var lab = state.labs.filter(lab => lab.name === state.testDetails.test.lab)[0];
            var test = lab?.tests.filter(tst => tst.name === action.testOrdered)[0] ? lab.tests.filter(tst => tst.name === action.testOrdered)[0] : undefined;
            var genes = test && test.genes ? test.genes.map(gene => {
                return {
                    checked: false,
                    id: '',
                    gene: gene.name,
                    variant: gene.variant,
                    classification: '',
                    priorClassification: '',
                    rowNumber: ''
                }
            }) : [];
            return {
                ...state,
                testDetails: {
                    ...state.testDetails,
                    test: {
                        ...state.testDetails.test,
                        testOrdered: action.testOrdered,
                        genes: genes
                    }
                }

            };
        case ResultsTableActions.SET_DEFAULT_WIDTH:
            var accumulatedWidth = 0;
            var columns = state.testColumns.map((column,index,arr) => {
                if (index == arr.length - 1) {
                    var colWidth = action.width - accumulatedWidth;
                    return {...column, width: colWidth > 0 ? colWidth : column.minWidth};
                }
                var colWidth = column.width && column.width > 0 ? column.width : Math.max(action.width * column.default / 100, column.minWidth);
                colWidth = parseInt(colWidth, 10);
                accumulatedWidth += colWidth;
                return {...column, width: colWidth};
            });
            return {
                ...state,
                testColumns: columns
            };
        case ResultsTableActions.RESIZE_COLUMN:
            var accumulatedWidth = 0;
            var columns = state.testColumns.map((column, index, arr) => {
                if (index == arr.length - 1) return {...column, width: Math.max(window.innerWidth - 15 - accumulatedWidth, column.minWidth)};
                if (index === action.columnsObject.columnKey) {
                    accumulatedWidth += action.columnsObject.newColumnWidth;
                    return {...column, width: action.columnsObject.newColumnWidth};
                }
                accumulatedWidth += column.width;
                return column;
            });
            return {
                ...state,
                testColumns: columns
            };
        case PatientActions.SET_AMBRY_STATUS:
            return {
                ...state,
                ambryStatus: action.status,
            };
        case PatientActions.SET_COLUMNS_WIDTH:
            var columns = state.testColumns.map((column, index, arr) => {
                switch (column.title) {
                    case "Lab":
                        return {...column, width: action.columnsWidth.lab};
                    case "Test":
                        return {...column, width: action.columnsWidth.test};
                    case "Submitted Date":
                        return {...column, width: action.columnsWidth.submittedDate};
                    case "Reported Date":
                        return {...column, width: action.columnsWidth.reportedDate};
                    case "Reclass Date":
                        return {...column, width: action.columnsWidth.reclassDate};
                    case "Status":
                        return {...column, width: action.columnsWidth.status};
                    case "Result":
                        return {...column, width: action.columnsWidth.result};
                    case "Document":
                        return {...column, width: action.columnsWidth.document};
                    case "Notes":
                        return {...column, width: action.columnsWidth.notes};
                    default:
                        return column;
                }
            });
            return {
                ...state,
                testColumns: columns
            };
        case TestActions.RESET_MULTIPLE_REPORTS_FLAG:
            var currentTestIndex = state.tests.findIndex(test => test.id == action.id);
            return {
                ...state,
                tests : [
                    ...state.tests.slice(0, currentTestIndex),
                    {...state.tests[currentTestIndex], potentialFamilyMemberReports: false},
                    ...state.tests.slice(currentTestIndex + 1)
                ],
                testDetails: {
                    ...state.testDetails,
                    test: {
                        ...state.testDetails.test,
                        potentialFamilyMemberReports: false
                    },
                }
            };
        case TestActions.SET_BLACKLIST_FILE_EXTENSIONS:
            return {
                ...state,
                blacklistFileExtensions: action.payload
            };
        default:
            return state;
    }
};

const testsTools = (state, action) => {
    switch (action.type) {
        case TestActions.EDIT_TEST:
            var currentTestIndex = state.findIndex(test => test.id == action.test.id);
            if (currentTestIndex > -1) {
                return [
                    ...state.slice(0, currentTestIndex),
                    action.test,
                    ...state.slice(currentTestIndex + 1)
                ]
            } else return [
                ...state,
                action.test
            ];
        case TestActions.REMOVE_TEST:
            return state.filter(test => test.id != action.id);
        default:
            return state;
    }
};

const testDetailsTools = (state, action) => {
    switch (action.type) {
        case TestActions.ADD_GENES_TABLE_ROW:
            var newItem = {
                checked: false,
                id: generateId(),
                gene: '',
                variant: '',
                classification: '',
                priorClassification: '',
                rowNumber: '',
                notSaved: true,
            };
            return {
                ...state,
                test: {
                    ...state.test,
                    genes: [...state.test.genes, newItem]
                }
            };
        case TestActions.DELETE_GENES_TABLE_ROW:
            return {
                ...state,
                test: {
                    ...state.test,
                    genes: [...state.test.genes.filter(genes => !genes.checked || genes.checked === false)]
                }
            };
        case TestActions.UPDATE_TEST_DETAILS:
            return {
                ...state,
                test: {
                    ...state.test,
                    [action.fieldId]: action.value
                }
            };
        case TestActions.SELECT_GENE:
        case TestActions.SELECT_ALL_GENES:
        case TestActions.UPDATE_GENES_TABLE_ROW:
            return {
                ...state,
                test: {
                    ...state.test,
                    genes: genesTool(state.test.genes, action)
                }
            };
        case TestActions.SELECT_TEST_STATUS:
            return {
                ...state,
                test: {
                    ...state.test,
                    testStatus: action.status && action.status.length > 0 ? action.status : undefined,
                    genes: genesTool(state.test.genes, action)
                }
            };
        case TestActions.SET_VALIDATION_RESULT:
            return {
                ...state,
                errors: {...state.errors, [action.fieldId]: action.error}
            };
        case TestActions.UPLOAD_DOCS:
            var files = [];
            for (var i = 0; i < action.files.length; i++) {
                files.push(action.files[i]);
            }
            return {
                ...state,
                files: [
                    ...state.files,
                    ...files
                ]
            };
        case TestActions.UNLOAD_DOC:
            var files = state.files.filter(file => file.name !== action.name);
            return {
                ...state,
                files: files
            };
        case TestActions.SET_DOC_TO_DELETE:
            return {
                ...state,
                toDelete: [
                    ...state.toDelete,
                    action.id
                ]
            }
        case TestActions.DELETE_DOC:
            return {
                ...state,
                test: {
                    ...state.test,
                    documents: state.test.documents.filter(doc => doc.id != action.id)
                }
            };
        case PatientActions.SET_TEST_DETAILS_SAVING:
            return {
                ...state,
                saving: action.saving
            };
        default:
            return state;
    }
};

const genesTool = (state, action) => {
    switch (action.type) {
        case TestActions.SELECT_GENE:
            var geneIndex = state.findIndex(gene => gene.id == action.gene.id);
            return [
                ...state.slice(0, geneIndex),
                {...state[geneIndex], checked: action.gene.checked},
                ...state.slice(geneIndex + 1)
            ];
        case TestActions.SELECT_ALL_GENES:
            return state.map(gene => {
                if (gene.external) {
                    return gene;
                } else {
                    return {...gene, checked: action.checked};
                }
            });
        case TestActions.UPDATE_GENES_TABLE_ROW:
            var geneIndex = state.findIndex(gene => gene.id == action.gene.id);
            return [
                ...state.slice(0, geneIndex),
                {...state[geneIndex], [action.gene.fieldId]: action.gene.value},
                ...state.slice(geneIndex + 1)
            ];
        case TestActions.SELECT_TEST_STATUS:
            if (action.status === TestStatuses.REPORTED) {
                return state.map(gene => {return {...gene, classification: (!gene.classification || gene.classification.length < 1 ? 'Negative' : gene.classification)}});
            } else if (action.status === '\u5831\u544A\u6E08') { //reported status for the Japanese
                return state.map(gene => {return {...gene, classification: (!gene.classification || gene.classification.length < 1 ? '\u9670\u6027' : gene.classification)}});
            }
        default: return state;
    }
};

export default testResults;